// Client entry: build the Kernel and boot it. Every concern is a service now — config
// (the seed), net (the connection), audio (sound), ui (join panel / console / lobby /
// chat), render (the frame loop), and input (keyboard / mouse / touch). boot() runs their
// init → consolidate → ready phases, which wires them together and starts the render loop
// and input handlers. All game RULES live server-side; this whole client is presentation.

import { WORLD_SEED } from "../engine/chunks.js";
import { VERSION } from "../version.js";
import { Kernel } from "../glue/Kernel.js";
import { ConfigService } from "../services/ConfigService.js";
import { NetService } from "./services/net/NetService.js";
import { AudioService } from "./services/audio/AudioService.js";
import { UIService } from "./services/ui/UIService.js";
import { RenderService } from "./services/render/RenderService.js";
import { InputService } from "./services/input/InputService.js";

const kernel = new Kernel({
    services: {
        config: new ConfigService({ seed: WORLD_SEED }),
        net: new NetService(),
        audio: new AudioService(),
        ui: new UIService(),
        render: new RenderService(),
        input: new InputService(),
    },
});
const verEl = document.getElementById("version");
if (verEl) verEl.textContent = `v${VERSION}`;

await kernel.boot();
